import SendIcon from '@mui/icons-material/Send'
import { Box, IconButton, TextField } from '@mui/material'
import { useGroupChannelContext } from '@sendbird/uikit-react/GroupChannel/context'
import { useState } from 'react'

export const MessageInput = () => {
  const [messageText, setMessageText] = useState('')
  const { currentChannel: selectedChannel, sendUserMessage } =
    useGroupChannelContext()
  const hasValidStagedMessage = !!messageText.trim()

  if (!selectedChannel) return null

  const onClick = async () => {
    try {
      await sendUserMessage({ message: messageText })
      setMessageText('')
      selectedChannel.endTyping?.()
    } catch {
      // preserve draft on failure
    }
  }

  const sendStopTyping = async () => selectedChannel.endTyping?.()
  const isMultiline = messageText.includes('\n') || messageText.length > 60

  return (
    <Box
      flex="0 0 auto"
      width="100%"
      margin={t => t.spacing(1, 0)}
      paddingX={t => t.spacing(2)}>
      <TextField
        value={messageText}
        multiline
        fullWidth
        size="small"
        variant="outlined"
        placeholder="Type a message"
        InputProps={{
          sx: {
            borderRadius: isMultiline ? 4 : 36,
            fontSize: '1rem',
            background: 'white',
            transition: 'border-radius 0.2s ease',
          },
          fullWidth: true,
          endAdornment: (
            <IconButton
              size="small"
              disabled={!selectedChannel || !hasValidStagedMessage}
              onClick={onClick}>
              <SendIcon fontSize="small" />
            </IconButton>
          ),
        }}
        onChange={async event => {
          setMessageText(event.currentTarget.value)
          if (event.currentTarget.value) {
            selectedChannel.startTyping()
          } else {
            sendStopTyping()
          }
        }}
        onKeyDown={e => {
          if (e.metaKey && e.key === 'Enter') {
            e.preventDefault()
            if (!hasValidStagedMessage) return

            onClick()
          }
        }}
      />
    </Box>
  )
}
